import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-exclamation",
  "use": "icon-exclamation-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-exclamation\"><path d=\"M506.970353 240.941176a55.205647 55.205647 0 0 1 55.024941 59.78353l-22.528 270.305882a32.617412 32.617412 0 0 1-64.993882 0l-22.528-270.305882A55.205647 55.205647 0 0 1 506.970353 240.941176z m4.818823 540.009412a59.994353 59.994353 0 1 0 0-120.018823 59.994353 59.994353 0 0 0 0 120.018823z\" fill=\"#FF3B30\" p-id=\"3191\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol